type Question = {
  id: string;
  category: string;
  question: string;
  role: string;
};

type GroupedQuestion = {
  key: string;
  values: Question[];
};
export function groupBy(array: Question[], key: string): GroupedQuestion[] {
  return array.reduce((acc: GroupedQuestion[], obj) => {
    const keyValue = ((obj as Record<string, unknown>)[key] ??
      "Suggested questions") as string;
    const existingGroup = acc.find((item) => item.key === keyValue);

    if (existingGroup) {
      existingGroup.values.push(obj as Question);
    } else {
      acc.push({
        key: keyValue,
        values: [obj as Question],
      });
    }

    return acc;
  }, []);
}
